const isObject = (item) => {
  return (item && typeof item === 'object' && !Array.isArray(item));
}

// Recursive function for merging (!) two objects (!) which returns a 
// deep merge of those two objects
// Usage example deepObjectMerge({}, object1, object2)
export const deepObjectMerge = (target, ...sources) => {
  if (!sources.length) return target;
  const source = sources.shift();

  if (isObject(target) && isObject(source)) {
      for (const key in source) {
          if (isObject(source[key])) {
              if (!target[key]) Object.assign(target, { [key]: {} });
              deepObjectMerge(target[key], source[key]);
          } else {
              Object.assign(target, { [key]: source[key] });
          }
      }
  }
  return deepObjectMerge(target, ...sources);
}

export const deepObjectClone = (objects) => {
  return JSON.parse(JSON.stringify(objects));
}
export const getObjectByKey = (key, object, defaultValue = null) => {
  return object?.[key] ?? defaultValue;
}